module.exports = __webpack_public_path__ + "static/media/Warmup.95b3beaa.jpg";